import { checkIsPlatform, tokens } from '@airtel/air-design-system';
import { StyleSheet } from 'react-native';
export var getTableCellStyles = () => {
  return StyleSheet.create({
    container: {
      justifyContent: 'space-between',
      flexDirection: 'row',
      flex: 1,
      padding: tokens.spacing.SPACING_16,
      alignItems: 'center',
      flexShrink: 0
    },
    variableWidth: Object.assign({}, checkIsPlatform('web') && {
      wordBreak: 'break-all'
    }),
    actionsContainer: {
      justifyContent: 'space-evenly',
      flexWrap: 'wrap'
    },
    cellContainer: {
      flexDirection: 'column',
      marginRight: tokens.spacing.SPACING_8,
      flex: 1
    },
    subHeading: {
      marginTop: tokens.spacing.SPACING_4
    },
    infoTagText: {
      marginTop: tokens.spacing.SPACING_8
    },
    cta: {
      marginTop: tokens.spacing.SPACING_8
    },
    icon: {
      flexShrink: 0
    },
    actionIconsContainer: {
      flexDirection: 'row',
      justifyContent: 'center',
      alignItems: 'flex-end'
    }
  });
};